import { t } from '@lingui/core/macro'
import { Grid, Switch, Typography } from '@mui/material'
import { LearnMoreLink } from '@components'

interface Props {
  allowApproval: boolean | undefined
  handleToggleApproval: () => void
}

export const ApprovalSwitch = ({ allowApproval, handleToggleApproval }: Props) => (
  <>
    <Grid container justifyContent="flex-start" alignItems="center">
      <Typography variant="body1">
        {t`Configure templates to require approval on changes to data`}&nbsp;
        <LearnMoreLink href="https://support.claravine.com/hc/en-us/articles/4415420082445" />
      </Typography>
    </Grid>
    <Grid container justifyContent="flex-end" alignItems="center">
      <Switch
        checked={allowApproval}
        onChange={handleToggleApproval}
        name="allowApproval"
        color="primary"
      />
    </Grid>
  </>
)
